import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CardSlider2 from "../components/Slider/CardSlider2";
import RoiCTA from "../components/CTA/RoiCTA";
import FeaturedContent from "../components/Featured/FeaturedContent";
import CardContainer from "../components/Card/CardContainer";
import Card from "../components/Card/Card";
import { useModal } from "../context/ModalContext";
import FAQs from "../components/FAQ/FAQs";
import Testimonials from "../components/Testimonials/Testimonials";
import Page from "../layout/Page";

const faqData = [
  {
    question:
      "What is Shoora's RoadSense, and how does it enhance road safety?",
    answer:
      "Shoora's RoadSense is an AI-driven Dash Cam that detects potential collision risks in real-time and provides instant video retrieval for accident analysis. It features ADAS technology, including Lane Departure Warning, Forward Collision Warning, and Pedestrian Detection, to prevent accidents and enhance driver safety.",
  },
  {
    question:
      "How does RoadSense protect fleets against false accident claims?",
    answer:
      "RoadSense provides instant video retrieval, allowing fleet managers to access and download HD footage of accidents or incidents. This evidence helps protect against false claims, simplifies the process of determining fault, and minimizes legal costs.",
  },
  {
    question: "What driver training and support features does RoadSense offer?",
    answer:
      "RoadSense provides automated voice alerts and continuous monitoring of proximity, distractions, and driving patterns. The system trains drivers on-the-go, reinforcing safe driving practices through actionable feedback. Drivers also receive immediate assistance from Shoora's control room during critical moments.",
  },
  {
    question: "Can RoadSense integrate with existing fleet management systems?",
    answer:
      "Yes, RoadSense can integrate with existing fleet management systems, providing a seamless and comprehensive solution for fleet operators. Please contact us for more information on integration capabilities.",
  },
  {
    question:
      "How does RoadSense benefit fleet operators in terms of operational efficiency and cost savings?",
    answer:
      "RoadSense benefits fleet operators by reducing accidents, minimizing legal costs, and streamlining insurance procedures. By promoting safer driving habits and providing instant video retrieval, RoadSense helps fleet operators enhance operational efficiency, reduce costs, and improve their overall bottom line.",
  },
  {
    question: "What are some key benefits of RoadSense for fleet operators?",
    answer:
      "Some key benefits of RoadSense for fleet operators include reducing accidents, minimizing legal costs, streamlining insurance procedures, and promoting safer driving habits. By providing instant video retrieval and actionable feedback, RoadSense helps fleet operators enhance operational efficiency, reduce costs, and improve their overall bottom line.",
  },
];

const roadSenseFeatures = [
  {
    id: 1,
    category: "Feature",
    title: "ADAS (ADVANCE DRIVER ASSISTANCE SYSTEM)",
    description:
      "RoadSense is your ADAS solution for non-assisted vehicles, enhancing driver safety with voice training and auto-generated alerts.",
    image: "/images/features/5.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 2,
    category: "Feature",
    title: "Lane Departure Warning (LDW)",
    description:
      "Notifies the driver when the vehicle unintentionally drifts out of its lane.",
    image: "/images/features/6.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 3,
    category: "Feature",
    title: "Forward Collision Warning (FCW)",
    description:
      "Alerts the driver of a potential collision to prevent accidents.",
    image: "/images/features/7.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 4,
    category: "Feature",
    title: "Pedestrian Detection (PD)",
    description:
      "Detects pedestrians and warns the driver to prevent accidents.",
    image: "/images/features/8.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 5,
    category: "Feature",
    title: "Collision Footage Recording",
    description:
      "Captures accident footage and generates alerts for immediate response.",
    image: "/images/features/9.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 6,
    category: "Feature",
    title: "Proximity Alert",
    description:
      "Detects and trains drivers who follow other vehicles too closely.",
    image: "/images/features/10.png",
    // link: "#",
    // linkText: "Read more",
  },

  {
    id: 8,
    category: "Feature",
    title: "Instant Access to Event Video",
    description:
      "Receive immediate alerts and locate video evidence of driver distraction instantly.",
    image: "/images/features/11.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 9,
    category: "Feature",
    title: "HD Videos for Clear Visibility",
    description:
      "Get crystal-clear insights into vehicle surroundings with easily accessible HD dash cam footage.",
    image: "/images/features/9.png",
    // link: "#",
    // linkText: "Read more",
  },
  {
    id: 10,
    category: "Feature",
    title: "Real-time 2 Way Voice Communication",
    description:
      "Enables our control room to communicate with drivers in real-time, preventing life-threatening situations and accidents.",
    image: "/images/features/12.png",
    // link: "#",
    // linkText: "Read more",
  },
];

const RoadSense = () => {
  const { openModal } = useModal();
  const handleScroll = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <Page 
      title="RoadSense | Shoora - Road sense with smooth navigation"
    >
     

      <div className="about-hero hero-2 w-100">
        <img
          src="/images/hero/road-sense.webp"
          alt="Shoora Life Savers Hero"
          className="w-100"
          style={{ objectFit: "cover" }}
        />
        <div
          className="row position-absolute p-5 w-100"
          style={{ top: "80px" }}
        >
          <div className="col col-12 col-lg-6 pe-lg-5">
            <p
              className="fs-6 text-white mt-4"
              style={{ lineHeight: 0.5, marginBottom: "0px !important" }}
            >
              {/* Enhanced safety and safeguard your fleet */}
            </p>
            <h1
              className="text-accent fw-bold mb-4 display-3"
              style={{ lineHeight: 0.9, marginBottom: "0px !important" }}
            >
              Road
              <i className="fw-light text-light">Sense</i> <br />
            </h1>
            <p className="fs-5  text-accent">
              Revolutionising Fleet Safety and Road Excellence
            </p>
            <p className="fs-6 text-light mb-5 pe-5">
              With a road facing AI-driven Dash Cam for risk detection and
              instant video retrieval, ensuring overall accident prevention and
              vehicle protection when it matters most.
            </p>
            <div className="d-flex pb-5">
              <button className="btn btn-dark rounded-5" onClick={openModal}>
                See Plans & Pricing
              </button>
              <a
                className="ms-3 btn btn-link text-light fw-bold text-decoration-none"
                onClick={openModal}
                href="#cta"
              >
                Get a Demo
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Navigation Bar */}
      <div className="container-fluid bg-black sticky-top d-none d-lg-block">
        <div className="container nav-links">
          <ul className="navigation-group">
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("overview")}
                className="navigation-item-link btn btn-link text-white"
              >
                Overview
              </button>
            </li>

            <li className="navigation-item">
              <button
                onClick={() => handleScroll("features")}
                className="navigation-item-link btn btn-link text-white"
              >
                Features
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("benefits")}
                className="navigation-item-link btn btn-link text-white"
              >
                Benefits
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("testimonials")}
                className="navigation-item-link btn btn-link text-white"
              >
                Testimonials
              </button>
            </li>
            <li className="navigation-item">
              <button
                onClick={() => handleScroll("faqs")}
                className="navigation-item-link btn btn-link text-white"
              >
                FAQs
              </button>
            </li>
          </ul>
        </div>
      </div>
      <section id="overview" className="container">
        <div className="row align-items-center">
          <div className="col col-12 col-lg-6 ps-lg-5">
            <h6 className="fs-bold text-accent">Overview</h6>
            <h1 className="mb-4">
              Revolutionising Road Safety with Real-Time Collision Detection and
              Expert Driver Coaching
            </h1>
            <p className="mb-5">
              RoadSense is a groundbreaking ADAS device that actively scans the
              road for potential collision risks and provides seamless two-way
              communication between the driver and Shoora’s dedicated control
              room team for coaching, ensuring enhanced safety and swift
              assistance.
            </p>
          </div>
          <div className="col">
            <video
              height={450}
              width={800}
              autoPlay
              loop
              muted
              className="w-100 pt-5 p-lg-0 pe-0"
            >
              <source
                src="/videos/products/road-sense1.mp4"
                type="video/mp4"
              ></source>
            </video>
          </div>
        </div>
      </section>

      <section id="features" className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col col-12 col-lg-10 text-center">
            <h6 className="fs-bold text-accent">
              Instant video retrieval advantage
            </h6>
            <h1 className="mb-4">
              With Shoora's watchful eye on the road, protect your fleet from
              false accident claims using Dash Cam footage.
            </h1>
            <p className="mb-5">
              Instantly access and download accident videos and share crucial
              evidence with authorities to clear your drivers' name, leverage
              this to cut accident-related costs.
            </p>
          </div>
          {/* <div className="col">
                        <img src="/images/products/cabinalert1.png" alt="" className='w-100 pt-5 p-lg-0 pe-0' />

                    </div> */}
        </div>
      </section>

      <div className="my-5">
        <CardSlider2 data={roadSenseFeatures} />
      </div>

      <section id="benefits">
        <CardContainer
          heading="Benefits"
          desc="Discover how this solution drives business success while making roads safer."
        >
          <Card
            // category="Safety"
            bgColor="#f4f4f4"
            type="primary"
            headingColor="#0d004a"
            heading="Enhanced Collision Prevention"
            desc="RoadSense™ revolutionizes safety with AI-powered ADAS, providing real-time alerts for collisions, lane departures, and pedestrians. Two-way communication ensures expert emergency guidance, reducing accidents, protecting drivers and cargo, and enhancing operational efficiency."
            imgsrc="/images/benefits/4.png"
            // linkText="See Plans & Pricing"
          />
          <Card
            // category="Visibility"
            bgColor="#eaca13"
            type="vibrant"
            heading="Instant Video Retrieval and Liability Protection"
            desc="RoadSense™ captures HD footage of incidents and behaviors, enabling instant access for analysis. It prevents false claims, reduces legal costs, streamlines insurance, and protects fleet reputation."
            imgsrc="/images/benefits/5.png"
          />
          <Card
            // category="Coaching insights"
            type="primary"
            heading="Comprehensive Driver Training and Support"
            desc="RoadSense™ uses voice alerts, real-time monitoring, and Shoora’s support to train drivers, reinforce safety, enhance accountability, and boost fleet performance through continuous coaching and assistance."
            imgsrc="/images/benefits/6.png"
            // linkText="See Plans & Pricing"
          />
        </CardContainer>
      </section>

      <section id="testimonials" className="testimonials-section section">
        <div className="container">
          <Testimonials />
        </div>
      </section>

      <section id="faqs">
        <FAQs
          data={faqData}
          title="Your questions about RoadSense™, answered."
        />
      </section>
    </Page>
  );
};

export default RoadSense;
